import { render, staticRenderFns } from "./consoleMenu.vue?vue&type=template&id=4d5c8a88&scoped=true"
import script from "./consoleMenu.vue?vue&type=script&lang=js"
export * from "./consoleMenu.vue?vue&type=script&lang=js"
import style0 from "./consoleMenu.vue?vue&type=style&index=0&id=4d5c8a88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5c8a88",
  null
  
)

export default component.exports